var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page',[_c('base-container',[_c('div',{class:["cube-popup-list-item"]},[_c('popup-content')],1),_c('div',{class:["cube-popup-list-item"]},[_c('popup-position')],1),_c('div',{class:["cube-popup-list-item"]},[_c('popup-transition')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }